import {
  MUTATION_SINGLE_LOGIN,
  QUERY_AUTH_CODE,
  MUTATION_LOGOUT,
  QUERY_ME,
  MUTATION_SELECT_USER_ACCOUNT,
  QUERY_ME_MERCAFACIL_ADMIN,
} from '@/modules/login/graphql'
import integrationService from '@/services/IntegrationService'

// TODO todas as chamadas devem ser passadas por actions ?

export default {
  async singleLogin(payload, apolloService) {
    const { turnstileToken, ...data } = payload
    const response = await apolloService.mutate({
      mutation: MUTATION_SINGLE_LOGIN,
      variables: data,
      context: {
        headers: {
          'turnstile-token': turnstileToken,
        },
      },
    })

    return response
  },

  async getCode(apolloService, payload) {
    try {
      const {
        data: { token },
      } = await apolloService.query({
        query: QUERY_AUTH_CODE,
        fetchPolicy: 'no-cache',
        variables: { ...payload, redirectUrl: integrationService.getIntegrationRedirectURL() },
      })
      return token
    } catch (error) {
      const isRedirectNotAllowed = error.graphQLErrors?.some((graphQLError) => graphQLError.message === 'Redirect URL not allowed')
      if (!isRedirectNotAllowed || !integrationService.hasRedirect()) throw error

      integrationService.clearRedirectURL()
      return this.getCode(apolloService, payload)
    }
  },

  async selectUserAccount(apolloService, { accountId, turnstileToken }) {
    await apolloService.mutate({
      mutation: MUTATION_SELECT_USER_ACCOUNT,
      fetchPolicy: 'no-cache',
      variables: { accountId },
      context: {
        headers: turnstileToken ? { 'turnstile-token': turnstileToken } : {},
      },
    })
  },

  async isMercafacilAdmin(apolloService) {
    const {
      data: { me },
    } = await apolloService.query({
      query: QUERY_ME_MERCAFACIL_ADMIN,
      fetchPolicy: 'no-cache',
    })
    return me.mercafacilAdmin
  },

  async singleLogout(apolloService) {
    try {
      await apolloService.mutate({
        mutation: MUTATION_LOGOUT,
      })
    } catch (error) {
      console.error('Error trying to request logout:', error)
    }
  },

  async getMe(apolloService) {
    const {
      data: { me },
    } = await apolloService.query({
      query: QUERY_ME,
    })
    return me.multiAccount
  },
}
